import { render, staticRenderFns } from "./how-work-with-leads.vue?vue&type=template&id=153ef348&"
import script from "./how-work-with-leads.vue?vue&type=script&lang=js&"
export * from "./how-work-with-leads.vue?vue&type=script&lang=js&"
import style0 from "./how-work-with-leads.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/how-work-with-leads.vue
// module id = 1716
// module chunks = 0